import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface DateState {
  token: string;
  email: string;
}

const initialState: DateState = {
  token: '',
  email: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    authSuccessful: (
      state,
      action: PayloadAction<{
        token: string;
        email: string;
      }>
    ) => {
      state.token = action.payload.token;
      state.email = action.payload.email;
    },

    logoutUser: (state) => {
      state.token = '';
      state.email = '';
    },
  },
});

export const { authSuccessful, logoutUser } = userSlice.actions;

export default userSlice.reducer;

export {};
